import { Link } from "react-router-dom";
import { Users, ShieldCheck, Newspaper, Globe } from "lucide-react";

const VALUES = [
  [ShieldCheck, "Indépendance", "Une rédaction libre de toute pression politique ou économique."],
  [Newspaper, "Rigueur", "Chaque information est vérifiée, recoupée et sourcée avant publication."],
  [Globe, "Proximité", "Des correspondants à Kinshasa, Lubumbashi, Goma, Kisangani et Matadi."],
  [Users, "Ouverture", "Un espace de débat pour toutes les voix congolaises."],
];

export default function AProposPage() {
  return (
    <div className="space-y-12" data-testid="apropos-page">
      <div className="bg-[#111827] text-white p-8 md:p-12">
        <span className="badge-cat">À propos</span>
        <h1 className="font-heading text-4xl sm:text-5xl font-black mt-3">Chronique<span className="text-red-600">.cd</span>, l'information au cœur de la RDC</h1>
        <p className="text-zinc-400 mt-4 max-w-3xl leading-relaxed">Chronique.cd est un média d'information numérique congolais fondé à Kinshasa. Notre mission : offrir aux Congolais du pays et de la diaspora une information fiable, indépendante et accessible, sur les enjeux politiques, sociaux, culturels, éducatifs, sanitaires et sportifs qui façonnent la République démocratique du Congo.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {VALUES.map(([Icon, t, d]) => (
          <div key={t} className="news-card p-6"><div className="w-12 h-12 bg-red-600 text-white flex items-center justify-center mb-4"><Icon size={22} /></div><h3 className="font-heading font-extrabold text-lg">{t}</h3><p className="text-sm text-zinc-600 mt-2">{d}</p></div>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-8">
        <div className="bg-white border border-zinc-200 p-8">
          <h2 className="font-heading font-extrabold text-xl uppercase border-l-4 border-red-600 pl-3">Notre charte</h2>
          <ul className="mt-4 space-y-2 text-sm text-zinc-700 list-disc pl-5">
            <li>Respecter la vérité des faits et le droit du public à une information de qualité.</li>
            <li>Distinguer clairement information, analyse et opinion.</li>
            <li>Protéger nos sources et refuser toute forme de corruption.</li>
            <li>Rectifier promptement toute erreur publiée.</li>
            <li>Respecter la dignité et la vie privée des personnes.</li>
          </ul>
        </div>
        <div className="bg-red-600 text-white p-8 flex flex-col justify-between">
          <div><h2 className="font-heading font-extrabold text-xl uppercase">Notre équipe</h2><p className="mt-3 text-red-100">Journalistes, reporters, techniciens : découvrez les femmes et les hommes qui font Chronique.cd chaque jour.</p></div>
          <Link to="/a-propos/equipe" data-testid="apropos-equipe-link" className="inline-flex items-center gap-2 mt-6 bg-[#111827] px-5 py-3 text-xs font-bold uppercase tracking-wider hover:bg-black transition-colors w-fit"><Users size={16} /> Voir l'équipe</Link>
        </div>
      </div>
    </div>
  );
}
